import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-error405',
  templateUrl: './page-error405.component.html',
  styleUrls: ['./page-error405.component.css']
})
export class PageError405Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
